if (!customElements.get('aj-slideshow')) {
  customElements.define('aj-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.aj-slide-track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      if (!this.track || !this.slides.length) return;
      this.current = 0;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.show = (index, instant = false) => {
        const slide = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        this.track.scrollTo({left:slide.offsetLeft-this.slides[0].offsetLeft,behavior:instant||reduced?'instant':'smooth'});
      };
      const update = () => {
        const left = this.track.scrollLeft;
        let closest=0;
        this.slides.forEach((slide,i)=>{if(Math.abs(slide.offsetLeft-this.slides[0].offsetLeft-left)<Math.abs(this.slides[closest].offsetLeft-this.slides[0].offsetLeft-left))closest=i});
        this.current=closest;
        this.dots.forEach((dot,i)=>{if(i===closest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
        const status=this.querySelector('.aj-slider-status');
        if(status)status.textContent=`${closest+1} / ${this.slides.length}`;
      };
      let drag;
      this.track.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('a,button,input,select,textarea'))return;
        drag={x:event.clientX,left:this.track.scrollLeft,moved:false};
      },{signal});
      this.track.addEventListener('pointermove',event=>{
        if(!drag)return;
        const distance=event.clientX-drag.x;
        if(Math.abs(distance)>8){drag.moved=true;this.track.setPointerCapture(event.pointerId);this.track.style.scrollSnapType='none';this.track.style.scrollBehavior='auto';event.preventDefault();this.track.scrollLeft=drag.left-distance}
      },{signal});
      const endDrag=event=>{
        if(!drag)return;
        const moved=drag.moved;
        drag=null;
        this.track.style.scrollSnapType='';this.track.style.scrollBehavior='';
        if(this.track.hasPointerCapture(event.pointerId))this.track.releasePointerCapture(event.pointerId);
        if(moved){let closest=0;this.slides.forEach((slide,i)=>{if(Math.abs(slide.offsetLeft-this.slides[0].offsetLeft-this.track.scrollLeft)<Math.abs(this.slides[closest].offsetLeft-this.slides[0].offsetLeft-this.track.scrollLeft))closest=i});this.show(closest)}
      };
      this.track.addEventListener('pointerup',endDrag,{signal});
      this.track.addEventListener('pointercancel',endDrag,{signal});
      this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      let frame;
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true,signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>this.show(Number(dot.dataset.slideTo)),{signal}));
      this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.current+(event.key==='ArrowRight'?1:-1))}},{signal});
      document.addEventListener('shopify:block:select',event=>{const selected=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail?.blockId);if(selected>=0)this.show(selected,true)},{signal});
      this.observer=new ResizeObserver(()=>this.show(this.current,true));
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
  });
}
if(!window.ajCartListenerInstalled){
  window.ajCartListenerInstalled=true;
  document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(({cart})=>{if(cart)document.querySelectorAll('.aj-cart-count').forEach(el=>el.textContent=String(cart.totalQuantity))}).catch(()=>{})});
}
